import React from 'react';
import { ChipSelectorQuestion } from './ChipSelectorQuestion';
import { ACCOUNT_EXAMPLES } from '../../onboardingExamples';

interface AccountsQuestionProps {
  selectedValue: string;
  customValue: string;
  onSelectedChange: (value: string) => void;
  onCustomChange: (value: string) => void;
}

export const AccountsQuestion: React.FC<AccountsQuestionProps> = ({
  selectedValue,
  customValue,
  onSelectedChange,
  onCustomChange
}) => {
  return (
    <ChipSelectorQuestion
      label="Who are some specific people or accounts you'd like to follow?"
      description="Pick from these suggestions or type your own—use handles (@username), names, or even descriptions of who you want to follow."
      chips={ACCOUNT_EXAMPLES}
      selectedValue={selectedValue}
      customValue={customValue}
      onSelectedChange={onSelectedChange}
      onCustomChange={onCustomChange}
      placeholder="patent attorneys specializing in AI, Anthropic engineers working on Claude Code, semiconductor supply chain analysts, longevity researchers at UCSF, venture capitalists investing in biotech, former SpaceX engineers…"
    />
  );
};
